export default function FillSessionStorage(input) {
  const applicationId = sessionStorage.getItem('applicationId');
  const answers = sessionStorage.getItem(`answers_${applicationId}`);
  if (answers) {
    const prevAnswers = JSON.parse(answers).filter(
      (answer) => answer.inputName !== input.inputName
    );
    const newAnswers = [...prevAnswers, input];
    sessionStorage.setItem(`answers_${applicationId}`, JSON.stringify(newAnswers));
  } else {
    sessionStorage.setItem(`answers_${applicationId}`, JSON.stringify([input]));
  }
}
